export default __webpack_public_path__ + "static/media/eric-smith.bda851f4.jpg";